<template>
	<div class="trpay">
		<el-card class="trpay-main">
			<div class="tr-l1">
				<span>订单信息</span>
			</div>

			<div class="tr-l2" v-if="orderDetail.trainFlag == 1">
				<div v-for="(trainItem,trainIndex) in orderDetail.trLinkOrders" :key="trainItem.id" style="border-bottom: 1px solid #ddd;padding: 10px 0 ;">
					<p style="font-weight: 600;">第{{ trainIndex + 1 }}程</p>
				
					<div>
						<span>行程信息：</span>
						<span class="padL10"> {{trainItem.trainCode}}</span>
						<span class="padL10">{{trainItem.fromStationName}} - {{trainItem.toStationName}}</span>
						<span class="padL10">{{trainItem.fromTime}} - {{trainItem.toTime}}</span>
					</div>
					<div>
						<span>乘车时间：</span>
						<span class="padL10">{{trainItem.fromDate}}</span>
						<span class="padL10">{{trainItem.fromWeek}}</span>
					</div>
					<div>
						<span>座位席别：</span>
						<span class="padL10">{{trainItem.seatTypeName}}</span>
					</div>
					<div v-for="(item, index) in trainItem.psgList" :key="index">
						<span>乘车人：</span>
						<span class="padL10">{{item.passengerName}}</span>
						<span class="padL10">{{item.seatCode}}</span>
					</div>
				</div>
		
				<div>
					<span>订单金额：</span>
					<span class="colorzs padL10">￥{{payAmount}}</span>
				</div>
				
			</div>

			<div class="tr-l2" v-if="!orderDetail.trainFlag">

				<div>
						<span>行程信息：</span>
						<span class="padL10"> {{orderDetail.trainCode}}</span>
						<span class="padL10">{{orderDetail.fromStationName}} - {{orderDetail.toStationName}}</span>
						<span class="padL10">{{orderDetail.fromTime}} - {{orderDetail.toTime}}</span>
					</div>
					<div>
						<span>乘车时间：</span>
						<span class="padL10">{{orderDetail.fromDate}}</span>
						<span class="padL10">{{orderDetail.fromWeek}}</span>
					</div>
					<div>
						<span>座位席别：</span>
						<span class="padL10">{{orderDetail.seatTypeName}}</span>
					</div>
					<div v-for="(item, index) in orderDetail.psgList" :key="index">
						<span>乘车人：</span>
						<span class="padL10">{{item.passengerName}}</span>
						<span class="padL10">{{item.seatCode}}</span>
					</div>


				<div>
					<span>订单金额：</span>
					<span class="colorzs padL10">￥{{payAmount}}</span>
				</div>
			
			</div>
			
		</el-card>
	</div>
</template>

<script>
	export default{
		name:"TrPay",
		data(){
			return {
				
			}
		},
		props:{
			// 订单详情
			orderDetail:{
				type:Object,
				default(){
					return {}
				}
			},
			// 需要支付金额
			payAmount:{
				type:Number,
				default:0,
			}
		},
		
		
	}
</script>

<style lang="scss" scoped>
	.trpay{
		.trpay-main{
			text-align: left;
			.tr-l1{
				font-weight: bold;
				font-size: 20px;
			}
			.tr-l2{
				margin-left: 20px;
				font-size: 14px;
				line-height: 30px;
				padding: 10px 0;
				
				.colorzs{
					color: #FF9524;
				}
			}
			
		}
		.padL10{
			padding-left: 10px;
		}
		.padR10{
			padding-right: 10px;
		}
	}
</style>
